<template>
  <div class="connection-status">
    <div
      v-if="connected"
      id="connection-status--connected"
      class="connection-status--connected"
    >
      <b-icon-wifi />
      <b-badge class="connected-agents" pill variant="info">
        {{ availableAgentsByName.length }}
      </b-badge>
    </div>
    <div
      v-else
      id="connection-status--disconnected"
      class="connection-status--disconnected"
    >
      <b-icon-wifi-off />
    </div>
    <b-popover
      target="connection-status--connected"
      triggers="hover"
      placement="bottom"
    >
      Available Agents:
      <li
        v-for="agent in availableAgentsByName"
        :key="agent.sessionId"
      >
        {{ agent.agentName }}
      </li>
    </b-popover>
    <b-popover
      target="connection-status--disconnected"
      triggers="hover"
      placement="bottom"
    >
      Network Disconnected
    </b-popover>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";

export default {
  name: "ConnectionStatus",
  props: {
    connected: Boolean,
  },
  computed: {
    ...mapGetters("agency", ["availableAgents"]),
    availableAgentsByName() {
      return [...new Map(this.availableAgents.map(agent => [agent.agentId, agent])).values()];
    },
  },
};
</script>

<style lang="scss">
.connection-status {
  &--connected {
    position: relative;
    font-size: 1.5rem;
    font-weight: bold;
    cursor: pointer;
    color: #0acc95;
    
    .connected-agents {
      position: absolute;
      top: 2px;
      right: -4px;
      border-radius: 12px !important;
      font-size: 8px;
      padding: 4px;
    }
  }
  &--disconnected {
    font-size: 1.5rem;
    font-weight: bold;
    cursor: pointer;
    color: #ef5350;
  }
}
</style>
